import * as React from 'react';
import styled, { keyframes } from 'styled-components';

import { SidebarLoaderContext, type SidebarLoaderContextType } from '@process-advisor/process-miner/shared/providers/sidebarLoaderProvider';
import { getColor } from '@process-advisor/process-miner/shared/theme';

const animateLoader = keyframes`
    100% {
        opacity: 1;
    }
`;

const StyledWrapper = styled.div`
    display: none;
    align-items: center;
    justify-content: center;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 100;
    opacity: 0;
    background-color: rgba(145, 145, 145, 0.3);
    animation: ${animateLoader} 10ms 0.3s linear forwards;
`;

const animateCircle = keyframes`
    100% {
        transform: translate(-50%, -50%) rotate(360deg)
    }
`;

const CircularProgress = styled.div`
    width: 60px;
    height: 60px;
    border-radius: 50px;

    border: 10px;
    border-style: solid;
    border-color: transparent;
    border-top-color: ${getColor('blue')};
    border-right-color: ${getColor('blue')};
    border-bottom-color: ${getColor('blue')};

    position: absolute;
    animation: ${animateCircle} 0.8s linear infinite;

    transform: translate(-50%, -50%);
    aspect-ratio: 1;
    transform-origin: center;
`;

const promiseGenerator = (functionToLoad) =>
    new Promise((resolve) => {
        functionToLoad();
        resolve(null);
    });

export const SidebarLoader = () => {
    const { props, setProps } = React.useContext<SidebarLoaderContextType>(SidebarLoaderContext);
    const wrapperRef = React.useRef<HTMLDivElement>(null);

    const showLoader = (callback) => {
        if  (wrapperRef.current) wrapperRef.current.style.display = 'flex';
        setProps({ functionToLoad: null });
        window.requestAnimationFrame(callback);
    };
    const hideLoader = () => {
        if  (wrapperRef.current) wrapperRef.current.style.display = 'none';
        setProps({ functionToLoad: null });
    };

    React.useEffect(() => {
        if (props.functionToLoad) {
            showLoader(() =>
                setTimeout(() => {
                    promiseGenerator(props.functionToLoad).then(() => {
                        hideLoader();
                    });
                })
            );
        }
    }, [props.functionToLoad]);

    return (
        <StyledWrapper ref={wrapperRef}>
            <CircularProgress />
        </StyledWrapper>
    );
};
